const LOCAL_BACKEND_PORT_KEY = "andre_backend_port";
const DEFAULT_PRODUCTION_BACKEND = "https://andremourapassos.vercel.app";
const START_PORT = 8000;
const MAX_PORT = 8999;
const PROBE_TIMEOUT_MS = 180;

let backendBaseUrlPromise = null;

const isLocalhost = () =>
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

const probeBackendAtPort = async (port) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), PROBE_TIMEOUT_MS);

  try {
    const response = await fetch(`http://localhost:${port}/api/health`, {
      method: "GET",
      signal: controller.signal,
    });

    if (!response.ok) {
      return false;
    }

    const data = await response.json();
    return data?.service === "andre-backend";
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
};

const discoverLocalBackendBaseUrl = async () => {
  const savedPort = Number(window.localStorage.getItem(LOCAL_BACKEND_PORT_KEY));

  if (Number.isInteger(savedPort) && savedPort >= START_PORT && savedPort <= 65535) {
    const savedPortIsValid = await probeBackendAtPort(savedPort);
    if (savedPortIsValid) {
      return `http://localhost:${savedPort}`;
    }
  }

  for (let port = START_PORT; port <= MAX_PORT; port += 1) {
    // eslint-disable-next-line no-await-in-loop
    const isValidBackend = await probeBackendAtPort(port);
    if (isValidBackend) {
      window.localStorage.setItem(LOCAL_BACKEND_PORT_KEY, String(port));
      return `http://localhost:${port}`;
    }
  }

  throw new Error(`Backend nao encontrado entre as portas ${START_PORT}-${MAX_PORT}.`);
};

export const getBackendBaseUrl = async () => {
  if (!isLocalhost()) {
    return process.env.REACT_APP_BACKEND_URL || DEFAULT_PRODUCTION_BACKEND;
  }

  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }

  if (!backendBaseUrlPromise) {
    backendBaseUrlPromise = discoverLocalBackendBaseUrl();
  }

  return backendBaseUrlPromise;
};
